<template>
	<div class="wrap" :class="[layoutClass, { show_event: isEventShown, scroll: isScrollHeader }]">
		<!-- 기존 배너들... -->
		<PCBanner v-if="!isMobile && noticeBanner && isMainPage" :banner="noticeBanner" @close="closeEvent"
			@click="handleNoticeBannerClick" />

		<MobileBanner v-if="isMobile && noticeBanner && isMainPage" :banner="noticeBanner" @close="closeEvent"
			@click="handleNoticeBannerClick" @notToday="setDoNotShowToday" />

		<!-- 이벤트 보기 버튼 - MA_001 페이지에서만 표시 -->
		<div class="cont_center show_event_area" v-if="!isEventShown && hasValidPopup && isMainPage">
			<button type="button" class="btn_show_event" @click="showTopEvent">
				이벤트보기
			</button>
		</div>

		<HeaderLayout v-if="!$route.meta?.hideHeaderFooter" />

		<div class="container" @mouseover="gnbMouseOut">
			<router-view v-slot="{ Component, route }">
				<!-- keep-alive 할 컴포넌트만 캐시 -->
				<keep-alive include="HFO_BI_001,HFO_BI_001_KBPRM">
					<component v-if="route?.meta?.keepAlive" :is="Component" />
				</keep-alive>
				<!-- 그 외는 일반 렌더 -->
				<component v-if="!route?.meta?.keepAlive" :is="Component" />
			</router-view>

			<!-- 오른쪽 퀵 메뉴 -->
			<div class="quick_menu" v-if="!$route.meta?.hideHeaderFooter && !isSidebarHidden">
				<ul class="quick_list">
					<li v-if="!isKbPrmHost">
						<RouterLink to="/HFO_BI_003">
							<img src="@/assets/images/icon/btn_alliance.png" alt="제휴문의" />
						</RouterLink>
					</li>
					<li v-if="!isKbPrmHost">
						<!-- 카카오 채널 추가 버튼 수정 -->
						<a href="#" @click.prevent="addKakaoChannel">
							<img src="@/assets/images/icon/btn_kakao_add.png" alt="채널추가" />
						</a>
					</li>

					<li ref="wingBannerGroup" class="wing_banner_group" v-show="!isWingBannerFixed">
						<ul>
							<li v-for="(item, idx) in wingBanners" :key="idx" class="banner_side">
								<a href="#" @click.prevent="handleWingBannerClick(item)" rel="noopener">
									<img :src="makeBannerUrl(item.bannerPath)" :alt="item.bannerTitle || '윙 배너'" />
								</a>
							</li>
						</ul>
					</li>
				</ul>
			</div>

			<Teleport to="body">
				<ul v-if="isWingBannerFixed" class="wing_banner_group fixed" :style="wingBannerFixedStyle">
					<li v-for="(item, idx) in wingBanners" :key="idx" class="banner_side">
						<a href="#" @click.prevent="handleWingBannerClick(item)" rel="noopener">
							<img :src="makeBannerUrl(item.bannerPath)" :alt="item.bannerTitle || '윙 배너'" />
						</a>
					</li>
				</ul>
			</Teleport>
			<!-- //오른쪽 퀵 메뉴 -->

			<!-- 상단 이동 퀵 메뉴 -->
			<div class="quick_menu2" v-if="!$route.meta?.hideHeaderFooter && !isSidebarHidden" v-show="isVisible">
				<a href="#" @click.prevent="scrollToTop" class="btn-top">

				</a>
			</div>
			<!-- //상단 이동 퀵 메뉴 -->
		</div>

		<FooterLayout v-if="!$route.meta?.hideHeaderFooter" />

		<AlertPopup v-model="alertShow" title="알림">
			<template #layer_content>
				<p class="alert_txt">
					모든 항목은 필수 항목입니다.<br />
					빠짐없이 기입해 주세요.
				</p>
			</template>
		</AlertPopup>

		<AlertPopup v-model="confirmShow" title="확인" :customClass="dynamicClass">
			<template #layer_content>
				<p class="alert_txt">
					입력하신 내용으로<br />
					저장하시겠습니까?
				</p>

				<div class="btn_layer_area">
					<button type="button" class="btn_type1 small">확인</button>
				</div>
			</template>
		</AlertPopup>

		<!-- 카카오 채널 추가 결과 알림 팝업 -->
		<AlertPopup v-model="showKakaoAlert" title="알림">
			<template #layer_content>
				<p class="alert_txt">
					{{ kakaoAlertMessage }}
				</p>
			</template>
		</AlertPopup>

		<!-- 로그인 필요 AlertPopup 추가 -->
		<AlertPopup v-model="showLoginAlert" title="알림" class="alert_popup">
			<template #layer_content>
				<div class="alert-content">
					<p>{{ loginAlertMessage }}</p>
					<div class="alert-buttons">
						<button class="btn btn-primary" @click="handleLoginAlertConfirm">확인</button>
						<button class="btn btn-secondary" @click="handleLoginAlertCancel">취소</button>
					</div>
				</div>
			</template>
		</AlertPopup>
	</div>
</template>

<script>
import { siteHostname, currentSiteUrl } from "@/lib/Seo";
import HeaderLayout from "./components/layout/HeaderLayout.vue";
import FooterLayout from "./components/layout/FooterLayout.vue";
import AlertPopup from "@/components/AlertPopup";
import PCBanner from "@/components/PCBanner.vue";
import MobileBanner from "@/components/MobileBanner.vue";
import { getBranchUuid, getConfig, setConfig } from "@/lib/Config";
import { getAxiosCustom, getAxios } from "@/lib/AxiosCall";
import { emitter } from '@/lib/eventBus';
import { LOCAL_STORAGE_HVM_USERINFO } from "@/lib/Constant"; // 추가


export default {
	components: {
		HeaderLayout,
		FooterLayout,
		AlertPopup,
		PCBanner,
		MobileBanner,
	},
	data() {
		const hostname = siteHostname();
		const isKbPrmHost = hostname === "kbprm.hivitamin.co.kr";

		return {
			alertShow: false,
			confirmShow: false,
			dynamicClass: "confirm",
			layoutClass: "",
			isEventShown: true,
			isScrollHeader: false,
			isMobile: window.innerWidth <= 1023,
			isKbPrmHost,
			wingBanners: [],
			noticeBanner: null,
			hasValidPopup: false,
			isMainPage: false,
			// 카카오 채널 관련 데이터
			showKakaoAlert: false,
			kakaoAlertMessage: '',
			// 로그인 AlertPopup 관련 데이터 추가
			showLoginAlert: false,
			loginAlertMessage: '',
			isVisible: false, // Top 버튼 표시 여부 (스크롤 위치에 따라 변경)
			isWingBannerFixed: false,
			wingBannerFixedStyle: {},
			wingBannerFixedStartScrollY: 0,
		};
	},
	computed: {
		isSidebarHidden() {
			const path = this.$route?.path || "";
			return /^\/HFO_CP_001/.test(path);
		},
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
		window.addEventListener("resize", this.handleResize);
		this.fetchWingBanners();
		this.checkMainPage();
		this.fetchNoticeBanner();
		this.checkBannerVisibility();

		// 전체메뉴 클릭 이벤트 리스너 추가 (emitter만 사용)
		emitter.on('close-notice-banner', this.closeEvent);

		// 카카오 SDK 초기화 체크
		this.initKakaoSDK();
	},
	beforeUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
		window.removeEventListener("resize", this.handleResize);

		// 이벤트 리스너 제거 (emitter만 사용)
		emitter.off('close-notice-banner', this.closeEvent);
	},
	async created() {
		if (window.location.pathname === '/') {
			const currentUrl = currentSiteUrl();

			try {
				const res = await getAxios('/hvm/v1/common/branch', { siteUrl: currentUrl });
				let config = getConfig();
				let newBranch = res.branch || (res.config && res.config.branch);
				if (newBranch) {
					if (!config) config = { branch: newBranch };
					else config.branch = newBranch;
					setConfig(config);
				}
			} catch (e) {
				console.error('branchUuid API 호출 에러:', e);
			}
		}
	},
	methods: {
		// wingBanners 클릭 처리 - handleLinkClickAD와 동일한 로직 (약관 동의 제외)
		async handleWingBannerClick(banner) {
			console.log("App.vue: 윙 배너 클릭됨", banner);

			// 브랜드 UUID가 있으면 파라미터 방식으로 상세 페이지로 이동
			if (banner && banner.brandUuid) {
				console.log("App.vue: 윙 배너에 brandUuid 있어 파라미터 네비로 이동", banner.brandUuid);
				sessionStorage.setItem("brandUuid", banner.brandUuid);
				this.$router.push({ name: 'HFO_BI_002', params: { brandUuid: banner.brandUuid } });
				return;
			}

			// linkType이 LINK_NEW인 경우에만 특별 처리
			if (banner.linkType !== 'LINK_NEW') {
				console.log("App.vue: LINK_NEW가 아님, 기본 처리");
				this.handleDefaultWingBannerClick(banner);
				return;
			}

			// localStorage에서 사용자 정보 확인
			const userInfoString = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
			console.log("App.vue: 사용자 정보 확인", {
				userInfoString: userInfoString,
				hasInfo: !!userInfoString
			});

			if (!userInfoString) {
				console.log("App.vue: 로그인 정보 없음 - AlertPopup 표시");
				// AlertPopup 표시
				this.showLoginRequiredAlert();
				return;
			}

			try {
				const userInfo = JSON.parse(userInfoString);
				const userUuid = userInfo.userUuid;

				console.log("App.vue: 파싱된 사용자 정보", {
					userInfo: userInfo,
					userUuid: userUuid
				});

				if (!userUuid) {
					console.log("App.vue: userUuid 없음 - AlertPopup 표시");
					// AlertPopup 표시
					this.showLoginRequiredAlert();
					return;
				}

				// URL에 userUuid 파라미터 추가하여 이동
				const targetUrl = this.addUserUuidToUrl(banner.linkUrl, userUuid);

				console.log("App.vue: userUuid 포함하여 윙 배너 링크 이동", {
					원본URL: banner.linkUrl,
					최종URL: targetUrl,
					userUuid: userUuid
				});

				// 새 창에서 열기
				window.open(targetUrl, '_blank');

			} catch (error) {
				console.error("App.vue: 사용자 정보 파싱 실패", error);
				// 파싱 실패 시 AlertPopup 표시
				this.showLoginRequiredAlert();
			}
		},

		// 로그인 필요 AlertPopup 표시
		showLoginRequiredAlert() {
			console.log("App.vue: showLoginRequiredAlert 호출됨");

			this.loginAlertMessage = '로그인이 필요한 서비스입니다.\n로그인 페이지로 이동하시겠습니까?';
			this.showLoginAlert = true;

			console.log("App.vue: AlertPopup 설정 완료", {
				showLoginAlert: this.showLoginAlert,
				loginAlertMessage: this.loginAlertMessage
			});
		},

		// AlertPopup 확인 버튼 클릭 핸들러
		handleLoginAlertConfirm() {
			console.log("App.vue: AlertPopup 확인 버튼 클릭됨");
			this.showLoginAlert = false;
			// 로그인 페이지로 이동
			this.$router.push('/HFO_LO_001');
		},

		// AlertPopup 취소 버튼 클릭 핸들러
		handleLoginAlertCancel() {
			console.log("App.vue: AlertPopup 취소 버튼 클릭됨");
			this.showLoginAlert = false;
		},

		// URL에 userUuid 파라미터 추가하는 헬퍼 메서드
		addUserUuidToUrl(url, userUuid) {
			if (!url || !userUuid) {
				return url;
			}

			try {
				const urlObj = new URL(url);
				urlObj.searchParams.set('userUuid', userUuid);
				return urlObj.toString();
			} catch (error) {
				// URL 파싱 실패 시 쿼리스트링 방식으로 추가
				console.warn("App.vue: URL 파싱 실패, 쿼리스트링 방식으로 추가", error);

				const separator = url.includes('?') ? '&' : '?';
				return `${url}${separator}userUuid=${encodeURIComponent(userUuid)}`;
			}
		},

		// 기본 윙 배너 클릭 처리 (LINK_NEW가 아닌 경우)
		handleDefaultWingBannerClick(banner) {
			console.log("App.vue: 기본 윙 배너 클릭 처리", banner);

			// 브랜드 UUID가 있는 경우
			if (banner.brandUuid) {
				console.log("App.vue: 브랜드 페이지로 이동 (파라미터 방식)", banner.brandUuid);
				sessionStorage.setItem("brandUuid", banner.brandUuid);
				this.$router.push({ name: 'HFO_BI_002', params: { brandUuid: banner.brandUuid } });
				return;
			}

			// 링크 URL이 있는 경우
			if (banner.linkUrl) {
				const url = this.makeLink(banner.linkUrl);

				// linkType에 따른 처리
				switch (banner.linkType) {
					case 'LINK_SELF':
						// 같은 창에서 이동
						window.location.href = url;
						break;
					case 'LINK_BLANK':
					default:
						// 새 창에서 열기
						window.open(url, '_blank');
						break;
				}
			} else {
				console.warn("App.vue: 윙 배너에 링크 정보가 없습니다", banner);
			}
		},

		// 카카오 SDK 초기화 체크
		initKakaoSDK() {
			// 카카오 SDK가 로드되었는지 확인
			if (typeof window.Kakao !== 'undefined' && window.Kakao) {
				console.log('카카오 SDK 로드 완료');
			} else {
				console.warn('카카오 SDK가 로드되지 않았습니다. index.html에 Kakao SDK 스크립트를 확인해주세요.');
			}
		},

		// 카카오 채널 추가 메서드
		addKakaoChannel() {
			try {
				// 카카오 SDK 존재 여부 확인
				if (typeof window.Kakao === 'undefined' || !window.Kakao) {
					this.kakaoAlertMessage = '카카오 서비스를 이용할 수 없습니다.\n잠시 후 다시 시도해주세요.';
					this.showKakaoAlert = true;
					return;
				}

				// 카카오 채널 추가 API 호출
				window.Kakao.Channel.followChannel({
					channelPublicId: '_aFaen'
				});

				console.log('카카오 채널 추가 요청 완료');

			} catch (error) {
				console.error('카카오 채널 추가 오류:', error);
				this.kakaoAlertMessage = '카카오 채널 추가 중 오류가 발생했습니다.\n잠시 후 다시 시도해주세요.';
				this.showKakaoAlert = true;
			}
		},

		// 기존 메서드들...
		gnbMouseOut() {
			const headerEl = document.querySelector(".header");
			if (headerEl) {
				headerEl.classList.remove("open");
			}
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		},
		handleScroll() {
			this.isVisible = window.scrollY > 200;
			this.isScrollHeader = window.scrollY > 50;
			this.updateWingBannerPosition();
		},
		handleResize() {
			this.isMobile = window.innerWidth <= 1023;
			this.resetWingBannerPosition();
		},
		updateWingBannerPosition() {
			if (this.isMobile) return;

			if (this.isWingBannerFixed) {
				if (window.scrollY < this.wingBannerFixedStartScrollY) {
					this.resetWingBannerPosition();
				}
				return;
			}

			const wingBannerGroup = this.$refs.wingBannerGroup;
			if (!wingBannerGroup || !this.wingBanners.length) return;

			const rect = wingBannerGroup.getBoundingClientRect();
			const stickyTop = 100;
			if (rect.top <= stickyTop) {
				this.wingBannerFixedStyle = {
					left: `${rect.left}px`,
					top: `${stickyTop}px`,
					width: `${rect.width}px`,
				};
				this.wingBannerFixedStartScrollY = window.scrollY;
				this.isWingBannerFixed = true;
			}
		},
		resetWingBannerPosition() {
			this.isWingBannerFixed = false;
			this.wingBannerFixedStyle = {};
			this.wingBannerFixedStartScrollY = 0;
		},
		showTopEvent() {
			localStorage.removeItem('noticeBannerClosed');
			this.isEventShown = true;

			if (!this.noticeBanner) {
				this.fetchNoticeBanner();
			}
		},
		closeEvent() {
			localStorage.setItem('noticeBannerClosed', 'true');
			this.isEventShown = false;
			this.noticeBanner = null;
		},
		async fetchWingBanners() {
			try {
				const res = await getAxiosCustom("/hvm/v1/branch/banner", {
					//branchUuid: getBranchUuid(),
				});
				const list = res?.data?.page?.list || [];
				this.wingBanners = list
					.filter((b) => b.bannerType === "BANNER_WING")
					.sort((a, b) => parseInt(a.order) - parseInt(b.order));
			} catch (e) {
				console.error("윙 배너 로드 실패", e);
			}
		},
		makeBannerUrl(path) {
			return path
				? `${process.env.VUE_APP_IMAGE_BASE_URL}images/${path}`
				: "";
		},
		makeLink(url) {
			return url?.startsWith("http") ? url : `http://${url}`;
		},
		goBrand(uuid) {
			sessionStorage.setItem("brandUuid", uuid);
			this.$router.push("/HFO_BI_002");
		},
		checkMainPage() {
			this.isMainPage = this.$route.name === 'HFO_MA_001' || this.$route.path === '/';
		},

		// fetchNoticeBanner 메서드는 기존 코드 그대로 유지...
		async fetchNoticeBanner() {
			// 600ms 딜레이 추가
			setTimeout(async () => {
				try {
					if (!this.isMainPage) {
						console.log('메인 페이지가 아니므로 팝업을 로드하지 않습니다.');
						this.noticeBanner = null;
						this.isEventShown = false;
						this.hasValidPopup = false;
						return;
					}

					this.checkBannerVisibility();

					const expireTime = localStorage.getItem('noticeBannerExpire');
					if (expireTime && new Date().getTime() < parseInt(expireTime)) {
						console.log('오늘 하루 보지 않기 설정이 있어 배너를 로드하지 않습니다.');
						this.noticeBanner = null;
						this.isEventShown = false;
						this.hasValidPopup = false;
						return;
					}

					localStorage.removeItem('noticeBannerClosed');

					console.log('fetchNoticeBanner API 호출 시작 (600ms 딜레이 후)');
					const response = await getAxiosCustom("/hvm/v1/promotion/popup");

					if (response?.data?.page?.list) {
						const popupList = response.data.page.list;

						const pcPopup = popupList.find(item => item.popupDispType === 'POPUP_MAIN');
						const mobilePopup = popupList.find(item => item.popupDispType === 'POPUP_MOBILE');

						const isMobileDevice = window.innerWidth <= 1023;

						let selectedPopup;
						if (isMobileDevice && mobilePopup) {
							selectedPopup = mobilePopup;
							this.hasValidPopup = true;
							console.log("모바일 디바이스용 팝업 선택");
						} else if (!isMobileDevice && pcPopup) {
							selectedPopup = pcPopup;
							this.hasValidPopup = true;
							console.log("PC 디바이스용 팝업 선택");
						} else {
							this.hasValidPopup = false;
							console.log("해당 디바이스용 팝업이 없습니다.");
						}

						if (selectedPopup) {
							const mobileImgPath = isMobileDevice && mobilePopup ?
								process.env.VUE_APP_IMAGE_BASE_URL + "images/" + mobilePopup.path :
								process.env.VUE_APP_IMAGE_BASE_URL + "images/" + (selectedPopup.pathMo || selectedPopup.path);

							this.noticeBanner = {
								imgPath: process.env.VUE_APP_IMAGE_BASE_URL + "images/" + selectedPopup.path,
								imgPathMo: mobileImgPath,
								linkUrl: selectedPopup.linkUrl,
								linkType: selectedPopup.linkType,
								brandUuid: selectedPopup.brandUuid || "",
								title: selectedPopup.title || '공지사항',
								eventUuid: selectedPopup.eventUuid || selectedPopup.uuid || '',
								replyYn: selectedPopup.replyYn || 'N'
							};

							console.log('선택된 팝업 정보:', {
								타입: selectedPopup.popupDispType,
								링크URL: selectedPopup.linkUrl,
								링크타입: selectedPopup.linkType
							});

							this.isEventShown = true;
						} else {
							console.log("표시할 수 있는 팝업이 없습니다.");
							this.isEventShown = false;
							this.hasValidPopup = false;
						}
					} else {
						this.hasValidPopup = false;
					}
				} catch (error) {
					console.error("공지 배너 로드 실패:", error);
					this.isEventShown = false;
					this.hasValidPopup = false;
				}
			}, 500);
		},

		handleNoticeDetailClick() {
			if (!this.noticeBanner) return;

			sessionStorage.setItem('eventUuid', this.noticeBanner.eventUuid || this.noticeBanner.uuid || '');
			sessionStorage.setItem('replyYn', this.noticeBanner.replyYn || 'N');

			this.closeEvent();
			this.$router.push("/HFO_PR_003");
		},

		handleNoticeBannerClick(banner) {
			localStorage.setItem('noticeBannerClosed', 'true');

			// 우선순위: linkType/linkUrl → brandUuid
			if (banner.linkType && banner.linkUrl) {
				const url = this.makeLink(banner.linkUrl);
				if (banner.linkType === 'LINK_SELF') {
					// 현재 창에서 이동
					window.location.href = url;
				} else {
					// 새 창에서 열기 (LINK_NEW, LINK_BLANK 등)
					window.open(url, '_blank', 'noopener,noreferrer');
				}
			} else if (banner.brandUuid) {
				// 브랜드 UUID가 있을 때만 브랜드 상세로 이동
				sessionStorage.setItem("brandUuid", banner.brandUuid);
				this.$router.push("/HFO_BI_002");
			}
			this.closeEvent();
		},
		setDoNotShowToday() {
			const today = new Date();
			const expires = new Date(today);
			expires.setHours(23, 59, 59, 999);

			console.log('오늘 하루 보지 않기 설정: ', expires);

			localStorage.setItem('noticeBannerExpire', expires.getTime());
			this.isEventShown = false;
		},
		checkBannerVisibility() {
			const expireTime = localStorage.getItem('noticeBannerExpire');
			console.log('저장된 배너 만료 시간: ', expireTime ? new Date(parseInt(expireTime)) : '없음');

			const bannerClosed = localStorage.getItem('noticeBannerClosed') === 'true';

			if (expireTime && new Date().getTime() < parseInt(expireTime)) {
				console.log('오늘 하루 보지 않기 설정이 있어 배너를 표시하지 않습니다.');
				this.isEventShown = false;
				return true;
			} else if (bannerClosed) {
				console.log('현재 페이지에서 닫힌 상태입니다.');
				this.isEventShown = false;
				return false;
			} else if (expireTime) {
				console.log('배너 만료시간이 지났으므로 배너를 표시합니다.');
				localStorage.removeItem('noticeBannerExpire');
				return false;
			}

			return false;
		},
	},
	watch: {
		$route: {
			immediate: true,
			handler(to) {
				this.layoutClass = to.meta.layoutClass || "";
				this.checkMainPage();

				if (this.isMainPage) {
					this.fetchNoticeBanner();
				} else {
					this.noticeBanner = null;
					this.isEventShown = false;
					this.hasValidPopup = false;
				}
			},
		},
	},
}
</script>

<style>
/* 공지 배너 컨테이너 스타일 */
.notice_banner_container {
	position: relative;
	width: 100%;
	z-index: 2;
}

.mobile_close_btn {
	position: absolute;
	top: 10px;
	right: 10px;
	width: 32px;
	height: 32px;
	background: rgba(0, 0, 0, 0.5);
	border: none;
	border-radius: 50%;
	z-index: 5;
	cursor: pointer;
	display: none;
}

@media (max-width: 1023px) {
	.mobile_close_btn {
		display: block;
	}
}

.mobile_close_btn::before,
.mobile_close_btn::after {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 16px;
	height: 2px;
	background-color: white;
}

.mobile_close_btn::before {
	transform: translate(-50%, -50%) rotate(45deg);
}

.mobile_close_btn::after {
	transform: translate(-50%, -50%) rotate(-45deg);
}

.sr-only {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}

.notice_banner_area {
	position: relative;
	z-index: 100 !important;
}

.banner-link {
	display: block;
	position: relative;
	z-index: 3;
}

.banner-link img.pc_none {
	width: 100%;
	display: none;
}

@media (max-width: 1023px) {
	.banner-link img.pc_none {
		display: block;
	}
}

/* 상단 이동 퀵 메뉴 스타일 */
.quick_menu2 {
	position: fixed;
	bottom: 30px;
	right: 30px;
	z-index: 9999;
	display: block;
	transition: opacity 0.3s;
}

.quick_menu2 .btn-top {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 50px;
	height: 50px;
	background: url('@/assets/images/icon/arrow_top.png') no-repeat center center;
	background-color: rgba(0, 0, 0, 0.6);
	color: white;
	border-radius: 50%;
	text-decoration: none;
	font-weight: bold;
	font-size: 16px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	transition: background-color 0.3s;
}

.quick_menu2 .btn-top:hover {
	background-color: rgba(0, 0, 0, 0.8);
}

@media (max-width: 1023px) {
	.quick_menu2 {
		bottom: 20px;
		right: 20px;
	}

	.quick_menu2 .btn-top {
		width: 40px;
		height: 40px;
		font-size: 14px;
	}
}

@media (max-width: 1279px) {
	.quick_menu {
		display: none !important;
		/* 1280px 미만에서는 숨김 */
	}
}

@media (min-width: 1280px) {
	.quick_menu {
		display: block !important;
		/* 1280px 이상에서는 표시 */
	}
}
</style>
